module.exports = __webpack_public_path__ + "media/dorobek/assets/images/monograph-6c938c48110e299255af8560b5875bf4.svg";